const snack = require('../../../../../components/snack/snack')
const sentpaymentDialog = require('./sentpayment-dialog')

const checkDialogIds = [
  'checkPaymentNotFound',
  'checkGenerationDisabled',
  'checkBankInformationDisabled',
  'checkAccountNumberMissing',
  'checkRoutingNumberInvalid',
  'missingDefaultCheckSignature',
]

// Genera el reporte y abre el PDF. El estado Printed se confirma despues,
// por separado, para no asumir que abrir el documento equivale a imprimirlo.
export function printPdf(data, callback, errorCallback) {
  const formData = new FormData()
  formData.append('id', data.id)
  formData.append('type', data.type)
  formData.append('entity', data.entity)
  formData.append('reportName', data.report)

  if (Array.isArray(data.ids)) {
    formData.append('ids', JSON.stringify(data.ids))
  }

  if (data.checkFormat) {
    formData.append('checkFormat', data.checkFormat)
  }

  const controller = new AbortController()
  const timeout = setTimeout(() => { controller.abort() }, 30000)

  fetch('./server/php/report/report-pdf.php', {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin',
  })
    .then(async (response) => {
      const contentType = response.headers.get('content-type') || ''

      if (contentType.includes('application/json')) {
        const result = await response.json()

        if (data.report === 'sentpayment-check') {
          const errorId = result.error?.val
          const dialogId = checkDialogIds.includes(errorId) ? errorId : 'checkPrintError'
          sentpaymentDialog.start({ act: 'show', id: dialogId })

          if (typeof errorCallback === 'function') {
            errorCallback(data)
          }
          return null
        }

        throw new Error('report-pdf')
      }

      if (!response.ok || !contentType.includes('application/pdf')) {
        throw new Error('report-pdf')
      }

      return response.blob()
    })
    .then((blob) => {
      if (blob === null || blob === undefined) { return }

      const pdfBlob = new Blob([blob], { type: 'application/pdf' })
      const fileUrl = URL.createObjectURL(pdfBlob)
      const newTab = window.open(fileUrl, '_blank')

      if (newTab) {
        newTab.addEventListener('load', () => {
          URL.revokeObjectURL(fileUrl)
        }, { once: true })
      }

      if (typeof callback === 'function') {
        callback(data)
      }
    })
    .catch(() => {
      if (data.report === 'sentpayment-check') {
        sentpaymentDialog.start({ act: 'show', id: 'checkPrintError' })
      } else {
        snack.start({ act: 'show', id: 'downloadError' })
      }

      if (typeof errorCallback === 'function') {
        errorCallback(data)
      }
    })
    .finally(() => {
      clearTimeout(timeout)
    })
}
